import { message } from "antd";
import axios from "axios";
import { apiHeaders } from "../helper/apiHeader";

export const addTestResult = (value, dispatchHelper, dispatchAns) => {
  console.log("valuevalue", value);

  dispatchAns({
    type: "IS_LOADING",
    payload: true,
  });

  console.log(value);
  console.log(value.test_id);
  if (!value.skipAddTestResult) {
    //speed test image condition needs to be commented in future
    axios
      .post("/UserTestData", { data: value }, apiHeaders("addtestresult"))
      .then((res) => {
        if (res.data.status === "201") {
          dispatchHelper({
            type: "RUNNING_QUES_ID",
            payload: "submitted",
          });
          dispatchAns({
            type: "IS_LOADING",
            payload: false,
          });
        } else {
          message.error(res.data.msg);
          dispatchAns({ type: "IS_ERR" });
        }
      })
      .catch((err) => {
        // message.error("Please wait for sometime or check your internet connection. Try again!");
        dispatchAns({ type: "IS_ERR" });
      });
  } else {
    dispatchHelper({
      type: "RUNNING_QUES_ID",
      payload: "submitted",
    });
    dispatchAns({
      type: "IS_LOADING",
      payload: false,
    });
  }
};
